import Api from "./base/api-base";

export default class WorkerDailyReportSubApi {

  info (date, id) {
    return Api.link.get({
      links: [
        {endpoint: Api.endpoint.worker_daily_report_sub, id: date},
        {endpoint: Api.endpoint.user, id: id}
      ]
    });
  }

  store (params) {
    return Api.post({
      endpoint: Api.endpoint.worker_daily_report_sub,
      params: params
    });
  }

  update (id, params) {
    return Api.post({
      endpoint: Api.endpoint.worker_daily_report_sub,
      id: id,
      params: params
    });
  }

  delete (id) {
    return Api.delete({
      endpoint: Api.endpoint.worker_daily_report_sub,
      id: id
    });
  }

  updateStatus (date, user_id, status) {
    return Api.link.post({
      links: [
        {endpoint: Api.endpoint.worker_daily_report_sub, id: date},
        {endpoint: Api.endpoint.user, id: user_id},
        {endpoint: "/status", id: status},
      ]
    });
  }
}
